function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.2124 94.2419C50.2124 94.337 50.1974 94.4248 50.1749 94.5126C50.0549 94.9664 49.6724 95.3396 48.5549 94.3736C46.6649 92.7562 38.4674 89.2798 38.4674 89.2798C38.4674 89.2798 38.3849 88.6797 39.0224 88.1015C39.5324 87.6405 40.9499 84.8667 40.9499 84.8667C40.9499 84.8667 41.2274 85.401 42.1424 85.9206C42.8174 86.3012 43.8299 86.6671 45.3299 86.7988C45.7349 86.8354 46.1699 86.8574 46.6499 86.85C46.6499 86.85 47.3099 88.6651 47.8349 89.7482C48.2849 90.6704 49.5374 92.7196 50.0249 93.5173C50.1524 93.7442 50.2199 93.993 50.2124 94.2419Z",
  fill: "white",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.6295 95.8374C48.6295 95.8374 40.0421 91.1022 38.8571 90.568C37.6721 90.0337 38.4671 89.2799 38.4671 89.2799C38.4671 89.2799 46.6646 92.7562 48.5546 94.3737C49.6796 95.3324 50.0546 94.9665 50.1746 94.5127C50.1971 94.4249 50.2121 94.3298 50.2121 94.2419C50.4971 96.7522 48.6295 95.8374 48.6295 95.8374Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.6922 61.4032C44.6772 61.4325 43.5372 63.4085 40.7472 63.672C40.0872 63.7378 38.6247 63.5622 36.7722 63.2694C34.2447 62.8669 30.9897 62.2229 28.0647 61.6154C24.0147 60.7738 20.5947 59.998 20.5947 59.998C20.9022 59.654 21.1572 59.2735 21.3597 58.8636C21.8922 57.8024 22.1022 56.5875 22.1772 55.6288C22.2597 54.6481 22.1997 53.9309 22.1997 53.9309C22.1997 53.9309 28.0872 53.6674 32.8797 53.9016C35.0547 54.0041 37.0047 54.209 38.0697 54.5822C41.4597 55.7752 43.0947 52.4159 43.1172 52.372C43.1472 52.5184 43.1772 52.6721 43.2147 52.8258C43.4022 53.6381 43.6497 54.4651 43.9797 55.2848C44.5497 56.7266 44.7447 58.8929 44.6922 61.4032Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.6328 32.0264C54.0228 33.5047 56.1153 35.1295 58.3578 36.3956",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.6376 24.3857C48.6376 24.393 48.6376 24.393 48.6376 24.3857C45.0076 27.518 44.4226 23.9173 44.3926 23.7343C45.5101 23.8441 47.0551 24.0417 48.6376 24.3857Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8576 53.7333C20.8576 53.7333 20.3701 54.0992 20.0176 55.0799C19.7551 55.8045 19.5601 56.8657 19.6801 58.366C19.7101 58.7685 19.7701 59.2076 19.8526 59.676C19.8526 59.676 18.1651 60.6274 17.1901 61.33C16.3576 61.9301 14.5351 63.5036 13.8376 64.1111C13.6426 64.2794 13.4101 64.3892 13.1626 64.4185C13.0726 64.4331 12.9826 64.4331 12.8851 64.4258C12.4126 64.3819 11.9851 64.0672 12.7501 62.8084C14.0251 60.6713 16.0876 52.028 16.0876 52.028C16.0876 52.028 16.6651 51.8451 17.3401 52.372C17.8801 52.7965 20.8576 53.7333 20.8576 53.7333Z",
  fill: "white",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.1555 64.4185C10.718 65.1138 11.3105 63.1304 11.3105 63.1304C11.3105 63.1304 14.5505 53.8797 14.8805 52.6282C15.2105 51.3767 16.088 52.0281 16.088 52.0281C16.088 52.0281 14.0255 60.6714 12.743 62.8011C11.9855 64.0672 12.4055 64.3746 12.878 64.4185C12.9755 64.4331 13.0655 64.4331 13.1555 64.4185Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1852 55.6289C22.1102 56.5876 21.8927 57.8025 21.3677 58.8637L20.5277 58.6148L19.6877 58.366C19.5677 56.8657 19.7627 55.8045 20.0177 55.08L21.1052 55.3507L22.1852 55.6289Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1855 55.6289L21.1055 55.3581C21.2105 55.0873 22.208 53.9383 22.208 53.9383C22.208 53.9383 22.2605 54.6409 22.1855 55.6289Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.36 58.8563C21.1575 59.2662 20.9025 59.654 20.595 59.9907C20.595 59.9907 20.445 59.2149 20.52 58.6075L21.36 58.8563Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.2001 85.0277L45.8626 85.7157L45.3301 86.8062C43.8301 86.6744 42.8176 86.3085 42.1426 85.9279L42.7651 84.5154L43.0801 83.7982C44.0476 84.0031 45.2326 84.3691 46.2001 85.0277Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.0796 83.8056L42.7646 84.5228C41.9921 84.2008 41.2646 83.5568 41.2646 83.5568C41.2646 83.5568 42.0446 83.586 43.0796 83.8056Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.6923 86.7111C46.9048 86.5866 45.8623 85.7157 45.8623 85.7157L46.1998 85.0278C46.8298 85.4522 47.3698 86.0085 47.6923 86.7111Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.6377 24.3856H48.6452",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.95 19.7968C49.95 21.6777 48.42 23.2072 46.5375 23.2072C44.655 23.2072 43.125 21.685 43.125 19.7968C43.125 17.9159 44.655 16.3863 46.5375 16.3863C48.42 16.3863 49.95 17.9159 49.95 19.7968Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.7949 5.13767C33.4724 3.3812 33.5699 2.49565 33.5624 2.0053C33.5549 1.67596 33.4724 1.35394 33.1949 1.17098C32.4299 0.66599 32.3174 2.42978 32.3174 2.42978",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.6028 5.15966C32.3478 4.28142 32.3403 3.27877 32.3628 2.72256C32.3703 2.62009 32.3478 2.51763 32.3178 2.42249C32.2353 2.19561 32.0478 2.01265 31.8003 1.9541C30.4353 1.60281 31.0803 5.94275 31.6053 8.57013",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.0898 9.09708C35.7748 8.04319 36.5698 4.57417 37.1998 3.74716C38.0623 2.6201 36.9148 2.02729 36.1423 2.80306C35.6473 3.30073 35.4523 3.93013 35.3698 4.31802C35.3548 4.39852 35.2348 4.40584 35.2123 4.31802C35.0173 3.52029 34.9423 2.41517 34.9198 1.85164C34.9123 1.55158 34.8598 1.23688 34.6648 1.01C33.9148 0.131764 33.4873 1.58085 33.4873 1.58085",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.2254 34.6465C66.1954 34.6318 66.1729 34.6244 66.1504 34.6097",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.6503 8.81203C31.2378 8.89268 30.9678 8.96601 30.9678 8.96601L31.5978 8.57007C31.6203 8.65805 31.6353 8.73871 31.6503 8.81203Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.8446 71.9639C50.7521 80.051 47.6921 86.711 47.6921 86.711C47.3696 86.001 46.8296 85.4521 46.1996 85.0277C45.7121 84.6983 45.1796 84.4422 44.6396 84.2446C44.0996 84.047 43.5596 83.9006 43.0796 83.8055C42.0446 83.5859 41.2646 83.5566 41.2646 83.5566C41.2646 83.5566 42.5846 78.1774 43.5821 71.9712H52.8446V71.9639Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.7349 48.4785C42.7349 49.6934 42.8399 51.0181 43.1174 52.3794C43.0949 52.4233 41.4674 55.7825 38.0699 54.5896C37.0049 54.2163 35.0549 54.0114 32.8799 53.909L40.6799 41.4088C41.2874 41.6137 42.3524 41.8918 43.6799 42.0967C43.5749 42.4041 42.7349 45.0241 42.7349 48.4785Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.46 63.6867V72.0153H72.9525V88.1894H63.45V71.964H27.54V62.4498L28.065 61.6155C30.99 62.2229 34.245 62.867 36.7725 63.2695V63.6867H63.375V38.5033C63.8925 38.6131 64.2525 38.6131 64.3725 38.4813C64.38 38.474 64.3875 38.4594 64.395 38.4521C64.41 38.4228 64.4175 38.3862 64.4175 38.3423C64.4025 38.1813 64.425 38.0056 64.4625 37.8153C64.7475 36.5346 66.1125 34.7927 66.225 34.6464C66.2325 34.6391 66.2325 34.6391 66.2325 34.6391C65.28 34.2658 64.32 33.7974 63.375 33.2851V20.8288H62.955L57.57 29.5599C56.895 29.0623 56.325 28.6232 55.8975 28.2865C55.4775 27.9498 55.095 27.5766 54.7425 27.1667C53.9175 26.2153 52.5 25.5127 50.9175 25.0004L59.325 11.5195H72.975V63.6867H83.46Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.4579 63.6867H44.5879C44.6404 62.9036 44.6779 62.1352 44.6929 61.4033C44.7454 58.893 44.5504 56.7267 43.9804 55.285C43.6504 54.4653 43.4029 53.6383 43.2154 52.8259C43.1779 52.6722 43.1479 52.5258 43.1179 52.3721C42.8404 51.0109 42.7354 49.6862 42.7354 48.4713C42.7354 45.0169 43.5679 42.4042 43.6729 42.0895C45.3979 42.3603 47.5654 42.5213 49.7329 42.2505C50.9779 42.0968 52.2229 41.7967 53.3854 41.2991C51.5554 45.1487 54.2179 53.4773 54.2179 53.4773C54.9154 56.5657 54.8929 60.1006 54.4579 63.6867Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.6925 61.4033C44.6775 62.1352 44.64 62.9036 44.5875 63.6867H36.7725V63.2696C38.625 63.5696 40.0875 63.738 40.7475 63.6721C43.5375 63.4086 44.67 61.4326 44.6925 61.4033Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.3753 20.8288V33.2924C61.1853 32.1141 59.1003 30.687 57.5703 29.5599L62.9553 20.8288H63.3753Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.232 34.639C66.232 34.639 66.232 34.639 66.2245 34.6463C66.112 34.7853 64.747 36.5345 64.462 37.8152C64.417 38.0055 64.402 38.1812 64.417 38.3422C64.417 38.3861 64.417 38.4227 64.3945 38.452C64.387 38.4666 64.3795 38.4739 64.372 38.4812C64.252 38.613 63.892 38.613 63.3745 38.5032C62.2045 38.2544 60.232 37.4493 58.3645 36.3954C57.2695 38.8911 55.462 40.4133 53.392 41.2989C52.2295 41.7966 50.9845 42.0966 49.7395 42.2503C47.572 42.5211 45.4045 42.3674 43.6795 42.0893C42.3595 41.8771 41.2945 41.599 40.6795 41.4014C40.327 41.2843 40.1245 41.1891 40.1095 41.1525C40.1095 41.1525 40.012 29.7208 34.687 25.015C29.362 20.3018 30.9745 8.97255 30.9745 8.97255C30.9745 8.97255 31.237 8.89936 31.657 8.81885C32.7445 8.5993 34.882 8.31387 36.0895 9.09696C36.0895 9.09696 36.097 9.09696 36.097 9.10428C36.292 9.23602 36.4645 9.38971 36.607 9.57999C37.912 11.3877 35.8045 15.6984 42.7345 23.6171C42.7345 23.6171 43.3945 23.6464 44.407 23.7488C44.437 23.9318 45.022 27.5399 48.6445 24.4075C49.4095 24.5758 50.182 24.7734 50.9245 25.015C52.507 25.5273 53.9245 26.2299 54.7495 27.1813C55.102 27.5911 55.4845 27.9644 55.9045 28.301C56.3245 28.6377 56.8945 29.0768 57.577 29.5745C59.107 30.7015 61.192 32.1287 63.382 33.307C64.3195 33.7973 65.287 34.2657 66.232 34.639Z",
  fill: "white",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.3747 38.5033V63.6866H54.4572C54.8922 60.1005 54.9147 56.5656 54.2247 53.4845C54.2247 53.4845 51.5622 45.1559 53.3922 41.3063C55.4622 40.4208 57.2772 38.8985 58.3647 36.4028C60.2322 37.4494 62.2047 38.2544 63.3747 38.5033Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.5547 37.5079L72.3297 38.3057C71.8647 38.2105 71.0397 38.1081 69.5547 37.5079Z",
  fill: "#FF0000",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.6215 38.3937L72.3223 38.3057C72.3447 38.313 72.3672 38.313 72.3821 38.3203C72.4719 38.335 72.5467 38.3643 72.6215 38.3937Z",
  fill: "#FF0000",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.3076 38.5911L71.3851 39.2571C70.8601 39.1619 70.0126 38.9643 69.3076 38.5911Z",
  fill: "#FF0000",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.7598 39.3818L71.3848 39.2645C71.4223 39.2719 71.4598 39.2792 71.4973 39.2865C71.5948 39.2939 71.6848 39.3305 71.7598 39.3818Z",
  fill: "#FF0000",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.9754 38.3349C72.7954 38.3861 72.6304 38.3935 72.6229 38.3935C72.5479 38.3642 72.4654 38.3349 72.3904 38.3203C72.3679 38.313 72.3529 38.313 72.3304 38.3056L69.5554 37.5079C71.0404 38.108 71.8654 38.2105 72.3304 38.3056L72.6304 38.3935C72.7654 38.452 72.8929 38.5252 72.9829 38.635C73.0279 38.6862 73.0654 38.7448 73.0879 38.8179C73.1779 39.0375 73.1179 39.1766 72.9829 39.2717C72.6304 39.5059 71.7679 39.3815 71.7679 39.3815C71.6854 39.3302 71.6029 39.2937 71.5054 39.279C71.4679 39.2717 71.4304 39.2644 71.3929 39.2571L69.3154 38.5911C70.0204 38.9643 70.8679 39.1619 71.3929 39.2571L71.7679 39.3742C71.8654 39.4327 71.9479 39.5132 72.0004 39.6084C72.0604 39.7035 72.0904 39.8133 72.0979 39.9304C72.1579 41.2331 67.1404 39.2351 64.7404 37.9543C64.6429 37.9031 64.5529 37.8519 64.4629 37.8007C64.7479 36.5199 66.1129 34.7781 66.2254 34.6317C67.2304 35.0781 70.4179 35.0123 71.2729 34.6024C72.4729 34.0242 72.8029 35.1879 71.9404 35.7514C71.3929 36.1101 70.7704 36.1686 70.4029 36.1686C70.3204 36.1686 70.2979 36.2784 70.3729 36.3077C71.0704 36.637 72.0754 36.9224 72.5854 37.0468C72.7204 37.0834 72.8554 37.12 72.9829 37.1859C73.1104 37.2518 73.2229 37.3323 73.3054 37.442C73.7329 38.0056 73.3204 38.2398 72.9754 38.3349Z",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.3076 38.5911L71.3851 39.2571C70.8601 39.1619 70.0126 38.9643 69.3076 38.5911Z",
  fill: "#FF0000",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.4973 39.2792C71.5948 39.2939 71.6848 39.3305 71.7598 39.3818L71.3848 39.2645C71.4223 39.2645 71.4598 39.2719 71.4973 39.2792Z",
  fill: "#FF0000",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.5547 37.5079L72.3297 38.3057C71.8647 38.2105 71.0397 38.1081 69.5547 37.5079Z",
  fill: "#FF0000",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.6215 38.3937L72.3223 38.3057C72.3447 38.313 72.3672 38.313 72.3821 38.3203C72.4719 38.335 72.5467 38.3643 72.6215 38.3937Z",
  fill: "#FF0000",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3945 38.4521C64.4095 38.4229 64.417 38.3863 64.417 38.3424C64.402 38.1814 64.4245 38.0057 64.462 37.8154C64.552 37.8667 64.642 37.9179 64.7395 37.9691L64.3945 38.4521Z",
  fill: "#141414",
  stroke: "#141414",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 96,
  fill: "white"
})));

function SvgIllustrationActivationCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationActivationCode);
export default __webpack_public_path__ + "static/media/illustration-activation-code.65835432.svg";
export { ForwardRef as ReactComponent };